import { connect } from 'react-redux'
import { compose } from 'redux'
import { firebaseConnect} from 'react-redux-firebase'
import AppHeader from './AppHeader'

const enhance = compose(
  firebaseConnect(
    () => [
      'profile'
    ]
  ),
  connect(
    ({ firebase: { profile } }) => ({
      profile
    })
  )
)

export default enhance(AppHeader)


// WEBPACK FOOTER //
// ./src/components/AppHeader/AppHeaderContainer.js